import type { ComponentProps } from "react";

export function Chevron(props: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 21"
			fill="none"
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M5.413 8.939a.959.959 0 0 1 1.396 0L9.3 11.585a.959.959 0 0 0 1.396 0l2.492-2.646a.959.959 0 0 1 1.396 0l.054.057a.959.959 0 0 1 0 1.315l-3.269 3.47a1.86 1.86 0 0 1-2.742 0l-3.27-3.47a.959.959 0 0 1 0-1.315l.055-.057Z"
				clipRule="evenodd"
			/>
		</svg>
	);
}
